/** @internal */
export const None = {
  label: 'No Control',
  value: 'none'
};
